/** Functionality: 登入表單 Author: Neil Date: 2019/12/04 */
<template>
  <div class="wrapper">
    <div class="the-login">
      <div class="the-login__poster"></div>
      <the-panel :loading="loading" :commonAlert="alert" :additionMsg="message"
        @loginEvent="handleLoginEvent"></the-panel>
    </div>
    <div class="info">
      <the-info :serviceID="serviceID" :errorCode="rawAlert"></the-info>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ThePanel from "./ThePanel";
import TheInfo from './TheInfo'

const AUTH_DOMAIN = window.config.domainHost;

export default {
  components: {
    ThePanel,
    TheInfo,
  }, // End of components
  filters: {
    isTrue(val) {
      return val !== "";
    }, // isTrue
  }, // End of filters
  data() {
    return {
      loading: false,
      rawAlert: "",
      serviceID: "",
      alert: "",
      message: "",
    };
  }, // End of data  
  created() {
    this.serviceID = this.$route.query.srv
    if (this.$route.query.error) {
      let errMsg = this.$route.query.error
      this.rawAlert = errMsg;
      this.alert = this.$t(errMsg);
    }
  }, //End of created
  methods: {
    handleLoginEvent(formModel) {
      let account = formModel.username;
      let password = formModel.password;
      let redirectUri= formModel.service.uri;
      this.loading = true;
      axios
        .post(
          `https://${AUTH_DOMAIN}/login/authentication-service/authentication/login`,
          {
            account,
            password
          }
        )
        .then((res) => {
          const data = res.data;
          if (data.code === -1) {
            if (data.parameters && typeof data.parameters != Array) {
              this.alert = this.$t(data.message).format(data.parameters)
            } else if (data.parameters && typeof data.parameters == Array) {
              this.alert = this.$t(data.message).format(...data.parameters)
            } else {
              this.alert = this.$t(data.message)
              if (data.message == "WrongUserNameOrPassword") {
                this.message = this.$t("validate.passValid")
              }

            }
            this.loading = false;
          } // if
          else if (data.code === -2) {
            this.$router.push(`/resetPwd/${formModel.username}?msg=${data.message}`);
          } // else if
          else {
            window.location.href = `https://${AUTH_DOMAIN}${redirectUri}`;
          } // else
        })
        .catch(() => {
          this.alert = this.$t("warning.networkErr");
          this.loading = false;
        });
    }, // handleLoginBtnClick();
  }, // End of methods
}; // end of export
</script>
<style lang="scss">
@import "@/assets/scss/global.scss";

.wrapper {
  border-radius: 10px;
}

.the-login {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  max-width: 400px;
  width: 90vw;
  box-shadow: 5px 5px 15px 0px rgba(119, 119, 119, 0.2);

  @include respond-to(pc) {
    flex-direction: row;
    max-width: 1059px;
    height: 450px;
  }
}

.the-login__poster {
  flex-basis: 30%;
  background-image: url("~img/robot_bg_sm.jpg");
  border-radius: 10px 10px 0px 0px;
  min-height: 165px;

  @include respond-to(pc) {
    transform: translateX(-1px);
    flex-basis: 60%;
    background-image: url("~img/robot_bg.jpg");
    border-radius: 10px 0px 0px 10px;
    background-position: center center;
  }

  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
}

// the-login__poster
</style>
